
namespace GeniuzPOS.Administration {

    @Serenity.Decorators.registerClass()
    @Serenity.Decorators.panel()
    export class CsParaDialog extends Serenity.EntityDialog<CsParaRow, any> {
        protected getFormKey() { return CsParaForm.formKey; }
        protected getIdProperty() { return CsParaRow.idProperty; }
        protected getLocalTextPrefix() { return CsParaRow.localTextPrefix; }
        protected getNameProperty() { return CsParaRow.nameProperty; }
        protected getService() { return CsParaService.baseUrl; }
        protected getDeletePermission() { return CsParaRow.deletePermission; }
        protected getInsertPermission() { return CsParaRow.insertPermission; }
        protected getUpdatePermission() { return CsParaRow.updatePermission; }

        protected form = new CsParaForm(this.idPrefix);

        constructor() {
            super();

            let helpPopover = new J.HelpPopover(this.form, this.getPropertyItems(), "i-am-a-class").init();
        }
        protected getToolbarButtons(): Serenity.ToolButton[] {
            let buttons = super.getToolbarButtons();
            // buttons.splice(Q.indexOf(buttons, x => x.cssClass == "panel-titlebar-close"), 1);
            // buttons.splice(Q.indexOf(buttons, x => x.cssClass == "panel-titlebar-close::after"), 1);

            
            buttons.push(
                {
                    title: Q.text("Close"),	// *** Get button text from translation
                    cssClass: '.panel-titlebar-close',
                    icon: 'fa-close',
                    hint: 'esc',
                    hotkey: 'esc',
                    onClick: () => {
                        window.location.href = '/';
                        return false;
                    },
                }
            );

            return buttons;
        }

        protected afterLoadEntity() {
            super.afterLoadEntity();

            this.deleteButton.hide();
            this.saveAndCloseButton.hide();
            this.cloneButton.hide();

            let self = this;
            let nbrRetry = 0;
            (function changeTitle() {
                if (nbrRetry >= 10) {
                    return;
                }

                setTimeout(() => {
                    if ((self as any).isMarkedAsPanel === true) {
                        if (self.element.find(".panel-titlebar").length == 1) {
                            // self.element.find(".panel-titlebar").html("");
                            //self.element.find(".panel-titlebar-text").html("");
                            self.element.find(".panel-titlebar-close").hide();//panel-titlebar
                        }
                        else {
                            changeTitle();
                        }
                    }
                    else {
                        if (self.element.parent().find(".panel-titlebar").length == 1) {
                            // self.element.parent().find(".panel-titlebar").html("");
                            // self.element.parent().find(".panel-titlebar-text").html("");
                            self.element.parent().find(".panel-titlebar-close").hide();
                        }
                        else {
                            changeTitle();
                        }
                    }
                }, 100);
            })();

            
        }
    }
}